module.exports = __webpack_public_path__ + "img/h6.8858ae29.jpg";